import React, { createContext, useContext, useReducer } from 'react';
import { Outlet } from 'react-router-dom';

const FavoriteMarketContext = createContext();
const FavoriteMarketsDispatchContext = createContext();
const LS_KEY = 'xs_favorite_markets';

export function useFavoriteMarkets() {
    return useContext(FavoriteMarketContext);
}

export function useFavoriteMarketsDispatch() {
    return useContext(FavoriteMarketsDispatchContext);
}

/*export function getFavoriteMarketsFromLS(key) {
    const saved = localStorage.getItem(key);
    if (saved == null) {
        return {};
    } else {
        const favorites = JSON.parse(saved);

        let maxTs = new Date();
        maxTs.setMinutes(maxTs.getHours() - 12);
        maxTs = +maxTs;
        const toDelete = new Set();
        Object.keys(favorites).forEach(key => {
            const ts = favorites[key]
            if (ts < maxTs) {
                toDelete.add(key);
            }
        });

        if (toDelete.size > 0) {
            toDelete.forEach(id => delete favorites[id]);
        }

        return favorites;
    }
}*/

export function getFavoriteMarketsFromLS(key) {
    const saved = localStorage.getItem(key);
    if (saved == null) {
        return {};
    } else {
        const favorites = JSON.parse(saved);

        let maxTs = new Date();
        maxTs.setHours(maxTs.getHours() - 12);
        maxTs = +maxTs;
        const toDelete = new Set();
        Object.keys(favorites).forEach(sportId => {
            Object.keys(favorites[sportId]).forEach(id => {
                const ts = favorites[sportId][id]
                if (ts < maxTs) {
                    toDelete.add({sportId:sportId,id:id});
                }
            });

            
        });

        if (toDelete.size > 0) {
            toDelete.forEach(d => {
                delete favorites[d.sportId][d.id]
                if(Object.keys(favorites[d.sportId])?.length == 0) {
                    delete favorites[d.sportId]
                }
            });
        }

        return favorites;
    }
}

export function isFavoriteMarket(bet) {
    const sportId = bet?.odds?.[0]?.matchData?.sportRef;
    const id = generateFavoriteMarketId(bet);
    return  getFavoriteMarketsFromLS(LS_KEY)?.[sportId]?.[id] != null;
}

export function generateFavoriteMarketId(bet) {
    if(bet) {
        return [bet.id, bet.handicap].join('_');
    }
}

function saveFavoriteMarketsToLS(key, favorites) {
    if (Object.values(favorites).length > 0) {
        localStorage.setItem(key, JSON.stringify(favorites));
    } else {
        localStorage.removeItem(key);
    }
}

/*function favoritesReducer(favorites, action) {
    switch (action.type) {
        case 'toggle': {
            if (favorites[action.id] == null) {
                favorites[action.id] = +new Date();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                delete favorites[action.id];
            }
            saveFavoriteMarketsToLS(LS_KEY, favorites);
            return {...favorites};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}*/

function favoritesReducer(favorites, action) {
    let id = generateFavoriteMarketId(action.bet);
    let sportId = action.bet?.odds?.[0]?.matchData?.sportRef;

    if(!id || ! sportId) {
        return;
    }

    switch (action.type) {
        case 'toggle': {
            if(favorites[sportId] == null) {
                favorites[sportId] = {};
            }
            if (favorites[sportId]?.[id] == null) {
                favorites[sportId][id] = +new Date();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                delete favorites[sportId][id];
                if(Object.keys(favorites[sportId])?.length == 0) {
                    delete favorites[sportId];
                }
            }
            saveFavoriteMarketsToLS(LS_KEY, favorites);
            return {...favorites};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

export default function FavoriteMarketsProvider() {
    const [favorites, dispatch] = useReducer(
        favoritesReducer,
        getFavoriteMarketsFromLS(LS_KEY)
    );

    return (
        <FavoriteMarketContext.Provider value={favorites}>
            <FavoriteMarketsDispatchContext.Provider value={dispatch}>
                <Outlet />
            </FavoriteMarketsDispatchContext.Provider>
        </FavoriteMarketContext.Provider>
    );
}
